/**
 * Barcha UI matnlari shu yerda. v2 (yangi PPTX) boʻyicha yangilangan.
 * Oʻzbek lotin imlo qoidalari: Oʻ/Gʻ — U+02BB, maʼ/eʼ/taʼ — U+02BC.
 */
export default {
  brand: {
    name: 'piima.uz',
    full: 'Maʼnaviyat yetakchisi — Respublika tanlovi',
  },

  nav: {
    home: 'Bosh sahifa',
    tartib: 'Tanlov tartibi',
    nizom: 'Nizom',
    murojaat: 'Murojaat',
    register: 'ROʻYXATDAN OʻTISH',
  },

  hero: {
    quote: 'Maʼnaviyat hayotimizda yangi kuch, yangi harakatga aylanishi kerak',
    attribution: 'Sh. M. Mirziyoyev',
    title: 'RESPUBLIKA TANLOVI',
    subtitle: 'Maʼnaviyat',
    subtitleAccent: 'YETAKCHISI',
    domain: 'www.piima.uz',
  },

  cta: {
    register: 'ROʻYXATDAN OʻTISH',
    learnMore: 'Batafsil',
    backToHome: 'Bosh sahifaga qaytish',
    downloadNizom: 'NIZOMNI YUKLAB OLING',
  },

  tartib: {
    title: 'TANLOVNI TASHKIL ETISH VA OʻTKAZISH TARTIBI',
    intro:
      'Tanlov ishtirokchilarga qulaylik va xolis baholanishni taʼminlash maqsadida ikki bosqichda tashkil etiladi. Har bir bosqich oʻziga xos talab va baholash mezonlariga ega.',
    stages: [
      {
        n: '1',
        title: 'Birinchi bosqich',
        subtitle: 'Onlayn ariza topshirish',
        body:
          'Ishtirokchilar 10-maydan 20-mayga qadar belgilangan platforma orqali oʻz loyihalari va hujjatlarini elektron shaklda topshiradilar. Hujjatlar toʻliqligi va talablarga muvofiqligi koʻrib chiqiladi (familiya, ism, sharif, tarjimai hol, qilingan ishlar taqdimoti, yangi loyihalar taqdimoti, yangi tashabbuslar). Hakamlar hayʼati tomonidan 20-maydan 30-mayga qadar barcha topshirilgan loyihalar oʻrganib chiqiladi, mezonlarga muvofiq eng yaxshi nomzodlar saralab olinadi va Respublika bosqichiga yoʻnaltiriladi.',
      },
      {
        n: '2',
        title: 'Ikkinchi bosqich',
        subtitle: 'Respublika final bosqichi',
        body:
          'Saralangan eng yaxshi nomzodlar Toshkent shahrida anʼanaviy (oflayn) tarzda bellashadilar. Bu bosqich 3 ta asosiy shart asosida oʻtkaziladi. Shartlar mazmuni tanlov boshlanishidan kamida bir hafta oldin eʼlon qilinadi.',
      },
    ],
  },

  nizom: {
    tabNizom: 'Nizom',
    tabQoidalar: 'Qoidalar',
    tabMurojaat: 'Murojaat',
    // Asosiy "NIZOM BILAN TANISHING" sahifasi (slide 4)
    nizomTitle: 'NIZOM BILAN TANISHING',
    nizomLead: '"Maʼnaviyat yetakchisi" — Respublika tanlovi',
    nizomBody:
      'Ushbu tanlov Prezident, ijod, sport, ixtisoslashtirilgan maktab va maktab-internatlarida faoliyat yuritayotgan maʼnaviy-maʼrifiy ishlar boʻyicha direktor oʻrinbosarlarining tajriba va yondashuvlarini ommalashtirish, shuningdek, maʼnaviy-maʼrifiy sohadagi samarali tashabbuslarni ragʻbatlantirishga qaratilgan.',
    maqsadTitle: 'Tanlovning maqsadi:',
    maqsadItems: [
      'Faol mutaxassislarni aniqlash, eʼtirof etish va ragʻbatlantirish;',
      'Yosh avlodni sogʻlom dunyoqarash asosida tarbiyalashga xizmat qiluvchi tashabbuslarni qoʻllab-quvvatlash;',
      'Milliy gʻoya va qadriyatlarni targʻib etuvchi tajribalarni ommalashtirish;',
      'Muvaffaqiyatli loyiha va tajribalarni respublika miqyosiga olib chiqishdan iborat.',
    ],
    bosqichlarTitle: 'Tanlov bosqichlari:',
    bosqichlarItems: [
      'Ishtirokchilar onlayn platforma orqali roʻyxatdan oʻtadilar. Saralash bosqichida hakamlar hayʼati tomonidan eng yaxshi nomzodlar saralab olinadi.',
      'Respublika bosqichi — ishtirokchilar oflayn tarzda 3 ta shart asosida bellashadi.',
    ],
    // "Qoidalar" tab — slide 3 dan, Nizom hujjatining 3 ta paragrafi
    qoidalarTitle: 'NIZOM',
    qoidalarLead: 'Tanlov toʻgʻrisidagi Nizom',
    qoidalarItems: [
      'Ushbu Nizom Ixtisoslashtirilgan taʼlim muassasalari agentligi tizimidagi maktablarning maʼnaviy-maʼrifiy ishlar boʻyicha direktor oʻrinbosarlari oʻrtasida "Maʼnaviyat yetakchisi" – Respublika tanlovini tashkil etish, oʻtkazish va ishtirokchilarni ragʻbatlantirish tartibini belgilaydi.',
      'Tanlov Agentlik tizimidagi Prezident, ijod, sport, ixtisoslashtirilgan maktab va maktab-internatlarining ilgʻor maʼnaviy-maʼrifiy ishlar boʻyicha direktor oʻrinbosarlarini aniqlash hamda ularning tajribasini ommalashtirishga qaratilgan. Bu esa ularning kasbiy rivojlanishi va samarali faoliyatiga zamin yaratadi.',
      'Tanlov Maktabgacha va maktab taʼlimi vazirligi, Maʼnaviyat va maʼrifat markazi hamda boshqa hamkor tashkilotlar bilan birgalikda tashkil etiladi. Bu hamkorlik tanlovning koʻlami va nufuzini oshirishga xizmat qiladi.',
    ],
    nizomPdfPath: '/manaviyat-yetakchisi-nizom.pdf',
  },

  murojaat: {
    title: 'BIZ BILAN BOGʻLANISH',
    lead: 'Murojaatingiz boʻlsa qoldiring.',
    name: 'Ism va familiya',
    phone: 'Telefon raqamingiz',
    email: 'Elektron pochta',
    subject: 'Mavzu',
    message: 'Murojaat matni',
    submit: 'YUBORISH',
    successToast: 'Murojaatingiz qabul qilindi. Tez orada javob beramiz.',
  },

  royxat: {
    pageTitle: 'Roʻyxatdan oʻtish',
    progress: '{current} / {total} bosqich',
    next: 'Davom ettirish',
    prev: 'Orqaga',
    submit: 'TASDIQLASH',
    saving: 'Yuborilmoqda...',
    steps: {
      fullName: {
        n: 1,
        label: 'Familiya, ism va sharifingizni yozing',
        placeholder: 'Yozing...',
      },
      region: {
        n: 2,
        label: 'Ish joyingiz joylashgan hududni tanlang',
        placeholder: 'Tanlang',
      },
      district: {
        n: 3,
        label: 'Ish joyingiz joylashgan tumanni tanlang',
        placeholder: 'Tanlang',
      },
      workplace: {
        n: 4,
        label: 'Ish joyingiz nomini yozing',
        placeholder: 'Yozing...',
      },
      phone: {
        n: 5,
        label: 'Telefon raqamingizni kiriting',
        placeholder: '+998 (__) ___-__-__',
      },
      obyektivka: {
        n: 6,
        label: 'Maʼlumotnomangizni yuklang (obyektivka)',
        hint: 'PDF, DOC yoki DOCX. Eng koʻpi 10 MB.',
        upload: 'Faylni yuklash',
      },
      portfel: {
        n: 7,
        label: 'Maʼnaviy-maʼrifiy ishlar portfoliyongizni yuklang',
        hint:
          '3 yil davomida amalga oshirgan loyihalar, yutuqlar, ota-onalar va jamoatchilik bilan hamkorlik, tahliliy yondashuvlar, ijtimoiy faollik, maktab faoliyatining OAV va ijtimoiy tarmoqlarda yoritilishi hamda videorolik. PDF, DOC, DOCX, ZIP yoki MP4. Eng koʻpi 20 MB.',
        upload: 'Faylni yuklash',
      },
      maqolalar: {
        n: 8,
        label: 'Ilmiy yoki maʼrifiy maqolalaringizni yuklang (PDF)',
        hint: 'Faqat PDF format. Eng koʻpi 10 MB.',
        upload: 'Faylni yuklash',
      },
    },
  },

  tasdiqlash: {
    title: 'Maʼlumotlaringizni koʻzdan kechirib chiqing',
    edit: 'Tahrirlash',
    confirm: 'TASDIQLASH',
  },

  muvaffaqiyat: {
    title: 'TABRIKLAYMIZ',
    body: 'Siz muvaffaqiyatli roʻyxatdan oʻtdingiz!',
    wish: 'TANLOVDA SIZGA OMAD TILAYMIZ!',
    publicId: 'Sizning ariza raqamingiz: {id}',
    backHome: 'Bosh sahifaga qaytish',
  },

  validation: {
    required: 'Ushbu maydon majburiy',
    minLength: 'Kamida {n} ta belgi kerak',
    maxLength: 'Eng koʻpi {n} ta belgi boʻlsin',
    invalidEmail: 'Elektron pochta manzili notoʻgʻri',
    invalidPhone: 'Telefon raqami notoʻgʻri',
    fileTooLarge: 'Fayl hajmi belgilangan chegaradan oshdi',
    fileType: 'Fayl formati qabul qilinmadi',
    duplicatePhone: 'Bu telefon raqami avval roʻyxatdan oʻtkazilgan',
  },

  errors: {
    network: 'Tarmoq xatosi. Internet aloqasini tekshiring.',
    server: 'Server xatosi. Birozdan keyin qayta urinib koʻring.',
    unknown: 'Kutilmagan xato yuz berdi.',
  },

  footer: {
    rights: '© 2026 piima.uz. Barcha huquqlar himoyalangan.',
    domain: 'www.piima.uz',
  },

  notFound: {
    title: '404',
    message: 'Sahifa topilmadi',
    home: 'Bosh sahifaga qaytish',
  },
}
